import React from "react"
import styled from "@emotion/styled"

const Container = styled.div`
  width: 32px;
  height: 12px;
  text-align: right;
  position: absolute;
  right: 24px;
  top: 20px;
  z-index: 4;
  cursor: pointer;
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    display: none;
  }
`
const LineTop = styled.div`
  width: 32px;
  height: 2px;
  background-color: ${props =>
    props.isOpen ? props.theme.secondary : props.theme.primary};
  top: ${props => (props.isOpen ? "5px" : "0")};
  transform: ${props => (props.isOpen ? "rotate(45deg)" : "rotate(0deg)")};
  position: absolute;
  transition: 0.4s;
`
const LineBot = styled.div`
  width: 32px;
  height: 2px;
  background-color: ${props =>
    props.isOpen ? props.theme.secondary : props.theme.primary};
  bottom: ${props => (props.isOpen ? "5px" : "0")};
  transform: ${props => (props.isOpen ? "rotate(-45deg)" : "rotate(0deg)")};
  position: absolute;
  transition: 0.4s;
`

export default function Hamburger({ onClick, isOpen, color }) {
  return (
    <Container onClick={onClick} isOpen={isOpen}>
      <LineTop color={color} isOpen={isOpen} />
      <LineBot color={color} isOpen={isOpen} />
    </Container>
  )
}
